import camelCase from "lodash/kebabCase";
import startCase from "lodash/startCase";

export function pascalCase(text: string) {
  return startCase(camelCase(text)).split(" ").join(""); //lodash does not have PascalCase yet
}

export function makePossessive(text: string) {
  if (text.endsWith("'") || text.endsWith("'s")) return text;
  if (text.endsWith("s")) return `${text}'`;
  return `${text}'s`;
}

export function capitalize(str: string) {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function capitalizeWords(str: string) {
  if (!str) return str;
  return str.split(" ").map(capitalize).join(" ");
}

export function formatDateMDY(dateStr: string | undefined) {
  if (!dateStr) return "";
  // Parse as local date to avoid timezone issues with date-only strings
  const [year, month, day] = dateStr.split("-").map(Number);
  return `${String(month).padStart(2, "0")}/${String(day).padStart(2, "0")}/${year}`;
}

/**
 * Converts a string to a URL-friendly slug.
 *
 * Converts the string to lowercase, replaces invalid characters with hyphens,
 * collapses multiple consecutive hyphens, and trims leading/trailing hyphens.
 *
 * @param text - The string to convert to a slug
 * @returns The slugified string
 */
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}
